<template>
  <div>
    <div class="content-container">
      <div class="feature-item mb-3">
        <div class="flex flex-wrap">
          <div class="w-3/4 md:w-2/3">
            <h4 class="text-s-l font-normal mb-0">Enable backup</h4>
            <p class="text-s-s text-surface-7">
              If your primary encoder fails, the stream automatically switches to the backup with no
              interruption. Both encoders must use identical settings for an uninterrupted switchover.
            </p>

          </div>
          <div class="text-right w-1/4 md:w-1/3">
            <Tooltip wrapper-class="inline-block" html interactive :active="this.streamAlive || linkedSource || failoverLimitReached" :content="tooltipMessage">
              <span class="inline-block">
                <FormSwitch
                  :class="{ 'pointer-events-none': this.streamAlive || linkedSource || failoverLimitReached }"
                  :disabled="failoverIngestToggleProcessing || this.streamAlive || !hasFailoverIngestFeature || linkedSource || failoverLimitReached"
                  @change="toggleBackup" v-model="failoverIngestToggleState" type="switch" :inputValue="true"
                  name="failover-ingest-toggle" />
              </span>
             </Tooltip>
          </div>
        </div>

        <Alert v-if="!hasFailoverIngestFeature" type="normal" class=" text-s-s flex p-3 mt-3">
          <div>
            <h3 class="mb-1 text-s-l font-normal text-dark-9">The backup feature is not available on your plan.
            </h3>
            <span class="">
              Please <a class="text-light-2 font-normal" href="/app/subscribe"><u>upgrade</u></a> plan to enable
              this feature.
            </span>
          </div>
        </Alert>

      </div>
    </div>

    <div v-if="false" class="feature-item mb-3"
      :style="[!failoverIngestToggleState || !hasFailoverIngestFeature ? 'opacity: 20%' : '']">
      <div class="w-3/4 md:w-3/4">
        <div class="flex flex-wrap">
          <FormButton :disabled="!hasFailoverIngestFeature" @click="onEncoderTabClick" :class="{
            '!bg-main-transparent !text-white !ring-main': selectedTab === 'encoder'
          }" class="mb-2 p-4" type="secondary" size="lg">
            <svg class="mr-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4396_4679)">
                <path
                  d="M19.5507 0.5852C19.1746 0.211494 18.6662 0.0012153 18.1359 0L7.19994 0C6.56362 0.000635372 5.95354 0.253696 5.50359 0.703645C5.05364 1.1536 4.80058 1.76368 4.79994 2.4V16.9372L0.351544 21.3856C0.240092 21.497 0.151682 21.6293 0.091364 21.7749C0.0310457 21.9205 0 22.0766 0 22.2342C0 22.3918 0.0310457 22.5479 0.091364 22.6935C0.151682 22.8391 0.240092 22.9714 0.351544 23.0828L0.917144 23.6484C1.14218 23.8734 1.44735 23.9997 1.76554 23.9997C2.08374 23.9997 2.38891 23.8734 2.61394 23.6484L4.79994 21.4624V21.6C4.80058 22.2363 5.05364 22.8464 5.50359 23.2964C5.95354 23.7463 6.56362 23.9994 7.19994 24H21.5999C22.2363 23.9994 22.8464 23.7463 23.2963 23.2964C23.7463 22.8464 23.9993 22.2363 23.9999 21.6V5.864C23.9987 5.33375 23.7885 4.82538 23.4147 4.4492L19.5507 0.5852ZM22.6343 4.8H19.9999C19.7878 4.8 19.5843 4.71571 19.4343 4.56569C19.2842 4.41566 19.1999 4.21217 19.1999 4V1.3656L22.6343 4.8ZM13.0799 12.052L11.9479 10.92L13.9275 8.9404C13.9647 8.90321 14.0088 8.87371 14.0574 8.85358C14.1059 8.83345 14.158 8.82308 14.2105 8.82308C14.2631 8.82308 14.3152 8.83345 14.3637 8.85358C14.4123 8.87371 14.4564 8.90321 14.4935 8.9404L15.0591 9.506C15.0963 9.54315 15.1258 9.58727 15.146 9.63582C15.1661 9.68438 15.1765 9.73643 15.1765 9.789C15.1765 9.84157 15.1661 9.89362 15.146 9.94218C15.1258 9.99074 15.0963 10.0349 15.0591 10.072L13.0799 12.052ZM11.3827 11.486L12.5139 12.6176L4.59394 20.5376L3.46274 19.406L11.3827 11.486ZM2.04794 23.0828C1.97186 23.1556 1.87063 23.1962 1.76534 23.1962C1.66005 23.1962 1.55882 23.1556 1.48274 23.0828L0.917144 22.5172C0.842155 22.4422 0.800029 22.3405 0.800029 22.2344C0.800029 22.1283 0.842155 22.0266 0.917144 21.9516L2.89714 19.9716L4.02794 21.1028L2.04794 23.0828ZM23.1999 21.6C23.1999 22.0243 23.0314 22.4313 22.7313 22.7314C22.4313 23.0314 22.0243 23.2 21.5999 23.2H7.19994C6.7756 23.2 6.36863 23.0314 6.06857 22.7314C5.76852 22.4313 5.59994 22.0243 5.59994 21.6V20.6624L15.6247 10.64C15.7362 10.5286 15.8246 10.3963 15.8849 10.2507C15.9452 10.1051 15.9763 9.949 15.9763 9.7914C15.9763 9.6338 15.9452 9.47774 15.8849 9.33213C15.8246 9.18653 15.7362 9.05423 15.6247 8.9428L15.0591 8.3772C14.9477 8.26575 14.8154 8.17734 14.6698 8.11702C14.5242 8.0567 14.3681 8.02566 14.2105 8.02566C14.0529 8.02566 13.8969 8.0567 13.7513 8.11702C13.6057 8.17734 13.4734 8.26575 13.3619 8.3772L5.59994 16.1372V2.4C5.59994 1.97565 5.76852 1.56869 6.06857 1.26863C6.36863 0.968571 6.7756 0.8 7.19994 0.8H18.1359C18.2249 0.800944 18.3134 0.811811 18.3999 0.8324V4C18.3999 4.42435 18.5685 4.83131 18.8686 5.13137C19.1686 5.43143 19.5756 5.6 19.9999 5.6H23.1675C23.1881 5.68652 23.199 5.77507 23.1999 5.864V21.6Z"
                  fill="#AEBAD6" />
                <path
                  d="M9.20005 5.2C9.41222 5.2 9.61571 5.11571 9.76573 4.96569C9.91576 4.81566 10 4.61217 10 4.4V2.8C10 2.58783 9.91576 2.38434 9.76573 2.23431C9.61571 2.08429 9.41222 2 9.20005 2H7.60005C7.38788 2 7.18439 2.08429 7.03436 2.23431C6.88433 2.38434 6.80005 2.58783 6.80005 2.8V4.4C6.80005 4.61217 6.88433 4.81566 7.03436 4.96569C7.18439 5.11571 7.38788 5.2 7.60005 5.2H9.20005ZM7.60005 2.8H9.20005V4.4H7.60005V2.8Z"
                  fill="#AEBAD6" />
                <path
                  d="M11.2 3.19999H12.8C12.9061 3.19999 13.0079 3.15785 13.0829 3.08284C13.1579 3.00782 13.2 2.90608 13.2 2.79999C13.2 2.69391 13.1579 2.59217 13.0829 2.51715C13.0079 2.44214 12.9061 2.39999 12.8 2.39999H11.2C11.094 2.39999 10.9922 2.44214 10.9172 2.51715C10.8422 2.59217 10.8 2.69391 10.8 2.79999C10.8 2.90608 10.8422 3.00782 10.9172 3.08284C10.9922 3.15785 11.094 3.19999 11.2 3.19999Z"
                  fill="#AEBAD6" />
                <path
                  d="M14.4 3.19999H17.2C17.3061 3.19999 17.4078 3.15785 17.4828 3.08284C17.5579 3.00782 17.6 2.90608 17.6 2.79999C17.6 2.69391 17.5579 2.59217 17.4828 2.51715C17.4078 2.44214 17.3061 2.39999 17.2 2.39999H14.4C14.2939 2.39999 14.1922 2.44214 14.1172 2.51715C14.0421 2.59217 14 2.69391 14 2.79999C14 2.90608 14.0421 3.00782 14.1172 3.08284C14.1922 3.15785 14.2939 3.19999 14.4 3.19999Z"
                  fill="#AEBAD6" />
                <path
                  d="M15.6 4H11.2C11.094 4 10.9922 4.04214 10.9172 4.11716C10.8422 4.19217 10.8 4.29391 10.8 4.4C10.8 4.50609 10.8422 4.60783 10.9172 4.68284C10.9922 4.75786 11.094 4.8 11.2 4.8H15.6C15.7061 4.8 15.8079 4.75786 15.8829 4.68284C15.9579 4.60783 16 4.50609 16 4.4C16 4.29391 15.9579 4.19217 15.8829 4.11716C15.8079 4.04214 15.7061 4 15.6 4Z"
                  fill="#AEBAD6" />
                <path
                  d="M17.6001 10.8V11.2C17.6001 11.3061 17.6422 11.4078 17.7173 11.4828C17.7923 11.5579 17.894 11.6 18.0001 11.6C18.1062 11.6 18.2079 11.5579 18.2829 11.4828C18.358 11.4078 18.4001 11.3061 18.4001 11.2V10.8C18.4001 10.6939 18.358 10.5922 18.2829 10.5172C18.2079 10.4421 18.1062 10.4 18.0001 10.4C17.894 10.4 17.7923 10.4421 17.7173 10.5172C17.6422 10.5922 17.6001 10.6939 17.6001 10.8Z"
                  fill="#AEBAD6" />
                <path
                  d="M18.0001 12.4C17.894 12.4 17.7923 12.4421 17.7173 12.5172C17.6422 12.5922 17.6001 12.6939 17.6001 12.8V13.2C17.6001 13.3061 17.6422 13.4078 17.7173 13.4828C17.7923 13.5579 17.894 13.6 18.0001 13.6C18.1062 13.6 18.2079 13.5579 18.2829 13.4828C18.358 13.4078 18.4001 13.3061 18.4001 13.2V12.8C18.4001 12.6939 18.358 12.5922 18.2829 12.5172C18.2079 12.4421 18.1062 12.4 18.0001 12.4Z"
                  fill="#AEBAD6" />
                <path
                  d="M19.1999 11.6H18.7999C18.6938 11.6 18.5921 11.6421 18.5171 11.7172C18.442 11.7922 18.3999 11.8939 18.3999 12C18.3999 12.1061 18.442 12.2078 18.5171 12.2828C18.5921 12.3579 18.6938 12.4 18.7999 12.4H19.1999C19.306 12.4 19.4077 12.3579 19.4827 12.2828C19.5578 12.2078 19.5999 12.1061 19.5999 12C19.5999 11.8939 19.5578 11.7922 19.4827 11.7172C19.4077 11.6421 19.306 11.6 19.1999 11.6Z"
                  fill="#AEBAD6" />
                <path
                  d="M17.1999 11.6H16.7999C16.6938 11.6 16.5921 11.6421 16.5171 11.7172C16.442 11.7922 16.3999 11.8939 16.3999 12C16.3999 12.1061 16.442 12.2078 16.5171 12.2828C16.5921 12.3579 16.6938 12.4 16.7999 12.4H17.1999C17.306 12.4 17.4077 12.3579 17.4827 12.2828C17.5578 12.2078 17.5999 12.1061 17.5999 12C17.5999 11.8939 17.5578 11.7922 17.4827 11.7172C17.4077 11.6421 17.306 11.6 17.1999 11.6Z"
                  fill="#AEBAD6" />
                <path
                  d="M9.19995 7.19999V7.59999C9.19995 7.70607 9.24209 7.80782 9.31711 7.88283C9.39212 7.95785 9.49386 7.99999 9.59995 7.99999C9.70604 7.99999 9.80778 7.95785 9.88279 7.88283C9.95781 7.80782 9.99995 7.70607 9.99995 7.59999V7.19999C9.99995 7.0939 9.95781 6.99216 9.88279 6.91714C9.80778 6.84213 9.70604 6.79999 9.59995 6.79999C9.49386 6.79999 9.39212 6.84213 9.31711 6.91714C9.24209 6.99216 9.19995 7.0939 9.19995 7.19999Z"
                  fill="#AEBAD6" />
                <path
                  d="M9.59995 8.79999C9.49386 8.79999 9.39212 8.84213 9.31711 8.91714C9.24209 8.99216 9.19995 9.0939 9.19995 9.19999V9.59999C9.19995 9.70607 9.24209 9.80782 9.31711 9.88283C9.39212 9.95785 9.49386 9.99999 9.59995 9.99999C9.70604 9.99999 9.80778 9.95785 9.88279 9.88283C9.95781 9.80782 9.99995 9.70607 9.99995 9.59999V9.19999C9.99995 9.0939 9.95781 8.99216 9.88279 8.91714C9.80778 8.84213 9.70604 8.79999 9.59995 8.79999Z"
                  fill="#AEBAD6" />
                <path
                  d="M10.8 8H10.4C10.2939 8 10.1922 8.04214 10.1172 8.11716C10.0421 8.19217 10 8.29391 10 8.4C10 8.50609 10.0421 8.60783 10.1172 8.68284C10.1922 8.75786 10.2939 8.8 10.4 8.8H10.8C10.9061 8.8 11.0078 8.75786 11.0828 8.68284C11.1579 8.60783 11.2 8.50609 11.2 8.4C11.2 8.29391 11.1579 8.19217 11.0828 8.11716C11.0078 8.04214 10.9061 8 10.8 8Z"
                  fill="#AEBAD6" />
                <path
                  d="M8.8 8H8.4C8.29391 8 8.19217 8.04214 8.11716 8.11716C8.04214 8.19217 8 8.29391 8 8.4C8 8.50609 8.04214 8.60783 8.11716 8.68284C8.19217 8.75786 8.29391 8.8 8.4 8.8H8.8C8.90609 8.8 9.00783 8.75786 9.08284 8.68284C9.15786 8.60783 9.2 8.50609 9.2 8.4C9.2 8.29391 9.15786 8.19217 9.08284 8.11716C9.00783 8.04214 8.90609 8 8.8 8Z"
                  fill="#AEBAD6" />
                <path
                  d="M17.4829 7.7172C17.4074 7.64434 17.3064 7.60402 17.2015 7.60493C17.0966 7.60585 16.9963 7.64791 16.9222 7.72208C16.848 7.79624 16.8059 7.89657 16.805 8.00144C16.8041 8.10632 16.8444 8.20736 16.9173 8.2828L17.0345 8.4L16.9173 8.5172C16.8791 8.5541 16.8486 8.59824 16.8276 8.64704C16.8067 8.69584 16.7956 8.74833 16.7952 8.80144C16.7947 8.85456 16.8048 8.90723 16.825 8.95639C16.8451 9.00554 16.8748 9.05021 16.9123 9.08776C16.9499 9.12532 16.9945 9.15502 17.0437 9.17513C17.0929 9.19525 17.1455 9.20537 17.1986 9.2049C17.2518 9.20444 17.3042 9.19341 17.353 9.17244C17.4018 9.15148 17.446 9.12101 17.4829 9.0828L17.6001 8.9656L17.7173 9.0828C17.7927 9.15567 17.8938 9.19599 17.9986 9.19507C18.1035 9.19416 18.2038 9.1521 18.278 9.07793C18.3522 9.00377 18.3942 8.90344 18.3952 8.79856C18.3961 8.69369 18.3557 8.59265 18.2829 8.5172L18.1657 8.4L18.2829 8.2828C18.3557 8.20736 18.3961 8.10632 18.3952 8.00144C18.3942 7.89657 18.3522 7.79624 18.278 7.72208C18.2038 7.64791 18.1035 7.60585 17.9986 7.60493C17.8938 7.60402 17.7927 7.64434 17.7173 7.7172L17.6001 7.8344L17.4829 7.7172Z"
                  fill="#AEBAD6" />
                <path
                  d="M8.68278 10.5172C8.60777 10.4422 8.50605 10.4001 8.39998 10.4001C8.29392 10.4001 8.19219 10.4422 8.11718 10.5172L7.99998 10.6344L7.88278 10.5172C7.80734 10.4443 7.7063 10.404 7.60142 10.4049C7.49654 10.4058 7.39622 10.4479 7.32206 10.5221C7.24789 10.5962 7.20583 10.6966 7.20491 10.8014C7.204 10.9063 7.24432 11.0074 7.31718 11.0828L7.43438 11.2L7.31718 11.3172C7.27898 11.3541 7.24851 11.3982 7.22754 11.447C7.20658 11.4958 7.19554 11.5483 7.19508 11.6014C7.19462 11.6546 7.20474 11.7072 7.22485 11.7564C7.24497 11.8055 7.27467 11.8502 7.31223 11.8878C7.34978 11.9253 7.39444 11.955 7.4436 11.9751C7.49276 11.9952 7.54543 12.0054 7.59854 12.0049C7.65166 12.0044 7.70414 11.9934 7.75295 11.9724C7.80175 11.9515 7.84589 11.921 7.88278 11.8828L7.99998 11.7656L8.11718 11.8828C8.19262 11.9557 8.29367 11.996 8.39854 11.9951C8.50342 11.9942 8.60375 11.9521 8.67791 11.8779C8.75207 11.8038 8.79414 11.7034 8.79505 11.5986C8.79596 11.4937 8.75565 11.3926 8.68278 11.3172L8.56558 11.2L8.68278 11.0828C8.75777 11.0078 8.7999 10.9061 8.7999 10.8C8.7999 10.6939 8.75777 10.5922 8.68278 10.5172Z"
                  fill="#AEBAD6" />
                <path
                  d="M15.8827 13.3172C15.8077 13.2422 15.706 13.2001 15.5999 13.2001C15.4939 13.2001 15.3921 13.2422 15.3171 13.3172L15.1999 13.4344L15.0827 13.3172C15.0073 13.2443 14.9063 13.204 14.8014 13.2049C14.6965 13.2058 14.5962 13.2479 14.522 13.3221C14.4478 13.3962 14.4058 13.4965 14.4049 13.6014C14.404 13.7063 14.4443 13.8073 14.5171 13.8828L14.6343 14L14.5171 14.1172C14.4789 14.1541 14.4485 14.1982 14.4275 14.247C14.4065 14.2958 14.3955 14.3483 14.395 14.4014C14.3946 14.4545 14.4047 14.5072 14.4248 14.5564C14.4449 14.6055 14.4746 14.6502 14.5122 14.6877C14.5497 14.7253 14.5944 14.755 14.6436 14.7751C14.6927 14.7952 14.7454 14.8053 14.7985 14.8049C14.8516 14.8044 14.9041 14.7934 14.9529 14.7724C15.0017 14.7515 15.0458 14.721 15.0827 14.6828L15.1999 14.5656L15.3171 14.6828C15.3926 14.7557 15.4936 14.796 15.5985 14.7951C15.7034 14.7941 15.8037 14.7521 15.8779 14.6779C15.952 14.6038 15.9941 14.5034 15.995 14.3985C15.9959 14.2937 15.9556 14.1926 15.8827 14.1172L15.7655 14L15.8827 13.8828C15.9577 13.8078 15.9998 13.7061 15.9998 13.6C15.9998 13.4939 15.9577 13.3922 15.8827 13.3172Z"
                  fill="#AEBAD6" />
                <path
                  d="M13.4828 5.71721C13.4078 5.64222 13.3061 5.6001 13.2 5.6001C13.094 5.6001 12.9922 5.64222 12.9172 5.71721L12.8 5.83441L12.6828 5.71721C12.6074 5.64435 12.5064 5.60403 12.4015 5.60494C12.2966 5.60585 12.1963 5.64792 12.1221 5.72208C12.0479 5.79625 12.0059 5.89657 12.005 6.00145C12.0041 6.10633 12.0444 6.20737 12.1172 6.28281L12.2344 6.40001L12.1172 6.51721C12.079 6.55411 12.0486 6.59825 12.0276 6.64705C12.0066 6.69585 11.9956 6.74834 11.9951 6.80145C11.9947 6.85456 12.0048 6.90723 12.0249 6.95639C12.045 7.00555 12.0747 7.05021 12.1123 7.08777C12.1498 7.12533 12.1945 7.15503 12.2437 7.17514C12.2928 7.19525 12.3455 7.20537 12.3986 7.20491C12.4517 7.20445 12.5042 7.19342 12.553 7.17245C12.6018 7.15149 12.6459 7.12102 12.6828 7.08281L12.8 6.96561L12.9172 7.08281C12.9927 7.15568 13.0937 7.19599 13.1986 7.19508C13.3035 7.19417 13.4038 7.1521 13.478 7.07794C13.5521 7.00378 13.5942 6.90345 13.5951 6.79857C13.596 6.69369 13.5557 6.59265 13.4828 6.51721L13.3656 6.40001L13.4828 6.28281C13.5578 6.2078 13.5999 6.10608 13.5999 6.00001C13.5999 5.89395 13.5578 5.79222 13.4828 5.71721Z"
                  fill="#AEBAD6" />
              </g>
              <defs>
                <clipPath id="clip0_4396_4679">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Encoder Level
          </FormButton>

          <FormButton :disabled="!hasFailoverIngestFeature" @click="onFileTabClick" :class="{
            '!bg-main-transparent !text-white !ring-main': selectedTab === 'file'
          }" class="file-btn-tab mb-2 p-4 ml-3" type="secondary" size="lg">
            <svg class="mr-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4396_4699)">
                <path
                  d="M19.5508 0.5852C19.1746 0.211494 18.6662 0.0012153 18.136 0L7.2 0C6.56368 0.000635372 5.9536 0.253696 5.50365 0.703645C5.0537 1.1536 4.80064 1.76368 4.8 2.4V8.4H2C1.46976 8.40064 0.961423 8.61155 0.586488 8.98649C0.211553 9.36142 0.000635143 9.86976 0 10.4L0 18.4C0.000635143 18.9302 0.211553 19.4386 0.586488 19.8135C0.961423 20.1884 1.46976 20.3994 2 20.4H4.8V21.6C4.80064 22.2363 5.0537 22.8464 5.50365 23.2964C5.9536 23.7463 6.56368 23.9994 7.2 24H21.6C22.2363 23.9994 22.8464 23.7463 23.2964 23.2964C23.7463 22.8464 23.9994 22.2363 24 21.6V5.864C23.9988 5.33375 23.7885 4.82538 23.4148 4.4492L19.5508 0.5852ZM22.6344 4.8H20C19.7878 4.8 19.5843 4.71571 19.4343 4.56569C19.2843 4.41566 19.2 4.21217 19.2 4V1.3656L22.6344 4.8ZM0.8 18.4V10.4C0.8 10.0817 0.926428 9.77652 1.15147 9.55147C1.37652 9.32643 1.68174 9.2 2 9.2H12.4C12.7183 9.2 13.0235 9.32643 13.2485 9.55147C13.4736 9.77652 13.6 10.0817 13.6 10.4V18.4C13.6 18.7183 13.4736 19.0235 13.2485 19.2485C13.0235 19.4736 12.7183 19.6 12.4 19.6H2C1.68174 19.6 1.37652 19.4736 1.15147 19.2485C0.926428 19.0235 0.8 18.7183 0.8 18.4ZM14.4 12.222L16.188 11.104C16.2486 11.0662 16.3181 11.0452 16.3895 11.0433C16.4609 11.0415 16.5315 11.0587 16.5939 11.0933C16.6564 11.128 16.7084 11.1787 16.7446 11.2402C16.7809 11.3017 16.8 11.3718 16.8 11.4432V17.3568C16.8 17.4282 16.7809 17.4983 16.7446 17.5598C16.7084 17.6213 16.6564 17.672 16.5939 17.7067C16.5315 17.7413 16.4609 17.7585 16.3895 17.7567C16.3181 17.7548 16.2486 17.7338 16.188 17.696L14.4 16.578V12.222ZM23.2 21.6C23.2 22.0243 23.0314 22.4313 22.7314 22.7314C22.4313 23.0314 22.0243 23.2 21.6 23.2H7.2C6.77565 23.2 6.36869 23.0314 6.06863 22.7314C5.76857 22.4313 5.6 22.0243 5.6 21.6V20.4H12.4C12.9302 20.3994 13.4386 20.1884 13.8135 19.8135C14.1884 19.4386 14.3994 18.9302 14.4 18.4V17.52L15.764 18.3728C15.9455 18.4863 16.1541 18.5491 16.3681 18.5548C16.5821 18.5605 16.7937 18.5088 16.981 18.4052C17.1683 18.3015 17.3245 18.1496 17.4333 17.9653C17.5422 17.781 17.5997 17.5709 17.6 17.3568V11.4432C17.6 11.229 17.5427 11.0187 17.4339 10.8341C17.3252 10.6496 17.1691 10.4975 16.9817 10.3936C16.7944 10.2898 16.5826 10.238 16.3685 10.2436C16.1544 10.2492 15.9456 10.3121 15.764 10.4256L14.4 11.28V10.4C14.3994 9.86976 14.1884 9.36142 13.8135 8.98649C13.4386 8.61155 12.9302 8.40064 12.4 8.4H5.6V2.4C5.6 1.97565 5.76857 1.56869 6.06863 1.26863C6.36869 0.968571 6.77565 0.8 7.2 0.8H18.136C18.2249 0.800944 18.3135 0.811811 18.4 0.8324V4C18.4 4.42435 18.5686 4.83131 18.8686 5.13137C19.1687 5.43143 19.5757 5.6 20 5.6H23.1676C23.1882 5.68652 23.1991 5.77507 23.2 5.864V21.6Z"
                  fill="#AEBAD6" />
                <path
                  d="M9.20005 2H7.60005C7.38788 2 7.18439 2.08429 7.03436 2.23431C6.88433 2.38434 6.80005 2.58783 6.80005 2.8V4.4C6.80005 4.61217 6.88433 4.81566 7.03436 4.96569C7.18439 5.11571 7.38788 5.2 7.60005 5.2H9.20005C9.41222 5.2 9.61571 5.11571 9.76573 4.96569C9.91576 4.81566 10 4.61217 10 4.4V2.8C10 2.58783 9.91576 2.38434 9.76573 2.23431C9.61571 2.08429 9.41222 2 9.20005 2ZM7.60005 4.4V2.8H9.20005V4.4H7.60005Z"
                  fill="#AEBAD6" />
                <path
                  d="M11.2 3.19999H12.8C12.9061 3.19999 13.0079 3.15785 13.0829 3.08284C13.1579 3.00782 13.2 2.90608 13.2 2.79999C13.2 2.69391 13.1579 2.59217 13.0829 2.51715C13.0079 2.44214 12.9061 2.39999 12.8 2.39999H11.2C11.094 2.39999 10.9922 2.44214 10.9172 2.51715C10.8422 2.59217 10.8 2.69391 10.8 2.79999C10.8 2.90608 10.8422 3.00782 10.9172 3.08284C10.9922 3.15785 11.094 3.19999 11.2 3.19999Z"
                  fill="#AEBAD6" />
                <path
                  d="M17.2 2.39999H14.4C14.2939 2.39999 14.1922 2.44214 14.1172 2.51715C14.0421 2.59217 14 2.69391 14 2.79999C14 2.90608 14.0421 3.00782 14.1172 3.08284C14.1922 3.15785 14.2939 3.19999 14.4 3.19999H17.2C17.3061 3.19999 17.4078 3.15785 17.4828 3.08284C17.5579 3.00782 17.6 2.90608 17.6 2.79999C17.6 2.69391 17.5579 2.59217 17.4828 2.51715C17.4078 2.44214 17.3061 2.39999 17.2 2.39999Z"
                  fill="#AEBAD6" />
                <path
                  d="M15.6 4H11.2C11.094 4 10.9922 4.04214 10.9172 4.11716C10.8422 4.19217 10.8 4.29391 10.8 4.4C10.8 4.50609 10.8422 4.60783 10.9172 4.68284C10.9922 4.75786 11.094 4.8 11.2 4.8H15.6C15.7061 4.8 15.8079 4.75786 15.8829 4.68284C15.9579 4.60783 16 4.50609 16 4.4C16 4.29391 15.9579 4.19217 15.8829 4.11716C15.8079 4.04214 15.7061 4 15.6 4Z"
                  fill="#AEBAD6" />
                <path
                  d="M8.9201 13.2948L6.4845 12.1164C6.30865 12.0307 6.11382 11.9914 5.91849 12.0021C5.72317 12.0129 5.53385 12.0735 5.3685 12.178C5.19279 12.2891 5.04836 12.4433 4.9489 12.6258C4.84943 12.8084 4.79821 13.0133 4.8001 13.2212V15.5788C4.79821 15.7867 4.84943 15.9916 4.9489 16.1742C5.04836 16.3567 5.19279 16.5109 5.3685 16.622C5.53394 16.7263 5.72324 16.7866 5.91852 16.7974C6.11379 16.8082 6.30858 16.769 6.4845 16.6836L8.9201 15.5052C9.12404 15.4014 9.2953 15.2433 9.41491 15.0482C9.53453 14.8532 9.59784 14.6288 9.59784 14.4C9.59784 14.1712 9.53453 13.9468 9.41491 13.7518C9.2953 13.5567 9.12404 13.3985 8.9201 13.2948ZM8.5717 14.7848L6.1361 15.9632C6.08225 15.9902 6.02224 16.0027 5.96208 15.9992C5.90192 15.9958 5.84372 15.9766 5.7933 15.9436C5.73268 15.9043 5.68312 15.8501 5.64931 15.7863C5.61549 15.7224 5.59856 15.651 5.6001 15.5788V13.2212C5.59856 13.149 5.61549 13.0775 5.64931 13.0137C5.68312 12.9498 5.73268 12.8957 5.7933 12.8564C5.84976 12.8204 5.91515 12.8009 5.9821 12.8C6.0356 12.8001 6.08833 12.8127 6.1361 12.8368L8.5717 14.0152C8.64038 14.0533 8.69761 14.109 8.73746 14.1767C8.77731 14.2444 8.79832 14.3215 8.79832 14.4C8.79832 14.4785 8.77731 14.5556 8.73746 14.6233C8.69761 14.6909 8.64038 14.7467 8.5717 14.7848Z"
                  fill="#AEBAD6" />
              </g>
              <defs>
                <clipPath id="clip0_4396_4699">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            File
          </FormButton>

          <p v-if="selectedTab === 'encoder'" class="text-s-s text-dark-7">
            <b>Encoder Level</b>: Use a secondary encoder to stream a backup if the primary stream fails.<br>
            <b>File Level</b>: Play a video file as a backup when the primary stream fails.
          </p>
        </div>
      </div>
    </div>

    <div v-if="selectedTab === 'file'" class="feature-item mt-3"
      :style="[!failoverIngestToggleState ? 'opacity: 20%' : '']">
      <div class="flex flex-wrap">
        <div class="w-full">
          <div class="flex items-center justify-center mt-3 mb-4">
            <div>
              <svg width="107" height="83" viewBox="0 0 107 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M81.0527 19.312C81.0527 29.3506 73.0693 37.6518 63.1388 38.2309C62.7493 38.2309 62.3599 38.2309 61.9704 38.2309C58.6603 38.2309 55.3501 37.2657 52.624 35.7212C46.7825 32.4394 42.8882 26.2618 42.8882 19.1189C42.8882 14.2927 44.6406 9.85252 47.7561 6.57067C51.261 2.70966 56.3237 0.200012 61.9704 0.200012C69.3697 0.200012 75.7954 4.44712 78.9108 10.6247C80.2738 13.3274 81.0527 16.2232 81.0527 19.312Z"
                  fill="#4F5C87" />
                <path opacity="0.1"
                  d="M80.8852 19.312C80.8852 29.3506 72.9018 37.6518 62.9713 38.2309C59.2716 37.6518 55.7667 36.6865 52.4566 35.9143C46.615 32.6325 42.7207 26.4549 42.7207 19.312C42.7207 14.4857 44.4732 10.0456 47.5886 6.76374C54.0143 6.57069 61.4135 7.14984 69.0075 8.50119C72.5124 9.08034 75.8226 9.85254 78.9381 10.6247C80.1064 13.3274 80.8852 16.2232 80.8852 19.312Z"
                  fill="#141E3D" />
                <path
                  d="M104.168 32.0884C105.637 23.9011 87.5176 13.8568 63.6963 9.65388C39.875 5.45097 19.3727 8.681 17.9031 16.8684C16.4335 25.0557 34.5532 35.1 58.3744 39.3029C82.1957 43.5058 102.698 40.2758 104.168 32.0884Z"
                  fill="#68759C" />
                <path
                  d="M57.6236 14.3288C57.732 12.9469 55.56 11.6525 52.7724 11.4376C49.9848 11.2227 47.6371 12.1687 47.5287 13.5506C47.4204 14.9325 49.5923 16.2269 52.38 16.4418C55.1676 16.6567 57.5153 15.7107 57.6236 14.3288Z"
                  fill="#8794B5" />
                <path
                  d="M33.123 17.878C35.8032 17.0891 37.6535 15.3725 37.2556 14.0438C36.8577 12.7151 34.3624 12.2776 31.6822 13.0665C29.0019 13.8555 27.1516 15.5721 27.5495 16.9008C27.9474 18.2294 30.4427 18.667 33.123 17.878Z"
                  fill="#8794B5" />
                <path
                  d="M77.3156 19.4079C77.5606 18.0434 75.5276 16.5435 72.775 16.0578C70.0223 15.5721 67.5922 16.2846 67.3473 17.6492C67.1024 19.0137 69.1353 20.5136 71.888 20.9993C74.6407 21.485 77.0707 20.7725 77.3156 19.4079Z"
                  fill="#8794B5" />
                <path
                  d="M92.0975 29.5021C92.7382 28.2702 91.243 26.2416 88.7579 24.9711C86.2728 23.7007 83.7388 23.6695 83.0981 24.9014C82.4574 26.1333 83.9526 28.1619 86.4377 29.4323C88.9228 30.7028 91.4567 30.734 92.0975 29.5021Z"
                  fill="#8794B5" />
                <path
                  d="M58.6071 26.2257L40.3037 26.0327L14.2373 74.5161L87.3996 82.2103L79.2471 32.7894L58.6071 26.2257Z"
                  fill="url(#paint0_linear_4398_4976)" />
                <path
                  d="M79.1306 33.2881C79.7901 29.6143 71.5704 25.0915 60.7714 23.1862C49.9724 21.2809 40.6835 22.7145 40.0241 26.3883C39.3647 30.0621 47.5844 34.5849 58.3834 36.4902C69.1823 38.3955 78.4712 36.9619 79.1306 33.2881Z"
                  fill="url(#paint1_linear_4398_4976)" />
                <path
                  d="M9.20828 51.0799C9.20828 51.0799 2.48216 52.7876 4.52038 54.1538C6.55859 55.4517 11.3824 57.7059 15.9344 56.2031C20.4864 54.7003 15.9344 52.5827 16.0023 52.5827C16.0703 52.5827 9.20828 51.0799 9.20828 51.0799Z"
                  fill="#404B72" />
                <path
                  d="M0.987305 50.5334C3.43316 51.2848 10.9746 50.0552 15.7983 46.913C19.603 51.6263 21.0298 52.8559 22.3886 52.9925C20.2824 55.1101 13.2845 58.5256 9.34399 54.0855C4.72404 57.0228 0.987305 50.5334 0.987305 50.5334Z"
                  fill="#8794B5" />
                <path
                  d="M81.7754 56.6822C84.3571 56.8188 91.355 53.6766 95.1597 49.4414C100.051 53.0618 101.682 53.8815 103.109 53.6766C101.546 56.2724 96.7902 61.942 90.0641 62.3519C85.1724 59.4829 81.7754 56.6822 81.7754 56.6822Z"
                  fill="#8794B5" />
                <path
                  d="M59.4003 56.7667C58.8895 54.2323 54.1031 48.2377 49.0537 45.6079C51.3415 39.9686 51.7292 38.1852 51.1753 36.8545C54.0785 37.7212 60.7542 40.9149 62.8265 47.3269C61.2665 52.7791 59.4003 56.7667 59.4003 56.7667Z"
                  fill="#8794B5" />
                <defs>
                  <linearGradient id="paint0_linear_4398_4976" x1="50.8232" y1="27.9842" x2="50.8232" y2="59.5161"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#DCE0E6" stop-opacity="0.53" />
                    <stop offset="1" stop-color="#364D7A" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_4398_4976" x1="59.5774" y1="34.9721" x2="62.4594" y2="25.0244"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#475681" />
                    <stop offset="1" stop-color="#272E45" />
                  </linearGradient>
                </defs>
              </svg>
              <!-- <span class="text-s-m text-dark-8">Coming soon</span> -->
            </div>
          </div>

          <div class="doc-area mt-2">
            <!-- <a class="text-s-s text-dark-6 inline-flex items-center" target="_blank"
                        href="https://docs.castr.com/en/articles/10586235-how-to-set-up-a-vod-backup-for-seamless-livestream-failover">
                        <img src="@/assets/images/book.png" class="mr-2" alt="Doc">How to setup a VOD Backup
                  </a> -->
            <FormButton @click="gotoDoc" class="doc" target="_blank" type="secondary">
              <icon-base class="text-dark-9" :width="16" :height="15" width-view-box="16" height-view-box="15"><icon-book-open /></icon-base>
              <div>How to setup a VOD Backup</div>
            </FormButton>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedTab === 'encoder' && hasFailoverIngestFeature" class="feature-item mt-3"
      :style="[!failoverIngestToggleState || !hasFailoverIngestFeature ? 'opacity: 20%' : '']">
      <h4 class="text-s-l font-normal mb-2">Publish Mode</h4>
      <div class="flex flex-wrap">
        <div class="w-full">
          <div class="flex items-center justify-between mb-1">
            <TabGroup type="segmented">
              <TabItem :is-active="publishType === 'rtmp'" @click="onPublishTypeChange('rtmp')">
                RTMP
              </TabItem>
              <TabItem :is-active="publishType === 'srt'" @click="onPublishTypeChange('srt')">
                SRT
              </TabItem>
            </TabGroup>
          </div>
        </div>
      </div>

      <div class="flex backup-section flex-col mt-3">
        <div class="flex flex-col p-4">
          <div v-if="failoverIgestActive" class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div class="flex flex-col gap-3">
              <IngestPreview :stream="stream" suffix="_primary" label="Primary ingest"
                :media-pulse="mediaPulsePrimary" :alive="primaryStreamAlive" :ref-link="9101" />
              <div class="rounded-md bg-surface-1 p-3">
                <p class="text-tiny font-medium text-surface-8 mb-2">Primary bitrate</p>
                <MonitoringChart v-if="isMonitoringAllowed && primaryStreamAlive" :key="primaryIngestKey"
                  :streamKey="primaryIngestKey" :streamAlive="primaryStreamAlive" :isAllowed="isMonitoringAllowed" />
                <p v-else-if="!isMonitoringAllowed" class="h-[100px] flex items-center justify-center text-center text-tiny text-surface-7 m-0 px-3">
                  <span><a href="/app/subscribe" class="text-main hover:underline">Upgrade</a> to view bitrate stats.</span>
                </p>
                <p v-else class="h-[100px] flex items-center justify-center text-center text-tiny text-surface-6 m-0 px-3">
                  Bitrate appears here once the primary ingest is live.
                </p>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <IngestPreview :stream="stream" suffix="_backup" label="Backup ingest"
                :media-pulse="mediaPulseBackup" :alive="backupStreamAlive" :ref-link="9102" />
              <div class="rounded-md bg-surface-1 p-3">
                <p class="text-tiny font-medium text-surface-8 mb-2">Backup bitrate</p>
                <MonitoringChart v-if="isMonitoringAllowed && backupStreamAlive" :key="backupIngestKey"
                  :streamKey="backupIngestKey" :streamAlive="backupStreamAlive" :isAllowed="isMonitoringAllowed" />
                <p v-else-if="!isMonitoringAllowed" class="h-[100px] flex items-center justify-center text-center text-tiny text-surface-7 m-0 px-3">
                  <span><a href="/app/subscribe" class="text-main hover:underline">Upgrade</a> to view bitrate stats.</span>
                </p>
                <p v-else class="h-[100px] flex items-center justify-center text-center text-tiny text-surface-6 m-0 px-3">
                  Bitrate appears here once the backup ingest is live.
                </p>
              </div>
            </div>
          </div>

          <Alert v-if="ingestMismatch.length" type="warning" class="mb-4"
            :text="`Your primary and backup encoders differ in ${ingestMismatchLabel}. For an uninterrupted failover, configure both encoders with identical settings.`" />

          <div class="flex flex-wrap">
            <div class="w-full">
              <label class="mt-3 text-s-m">Ingest Location</label>
              <div class="region mb-3">
                <StreamRegion
                  :selector-disabled="!failoverIngestToggleState || !hasFailoverIngestFeature || failoverIngestToggleProcessing"
                  :stream="stream" @switch-stream-region="switchStreamRegion" fullWidth show-alert />
              </div>
            </div>
          </div>

          <!-- <div class="flex flex-wrap">
            <div class="w-full">
              <label class="mt-3 text-s-m">Active Source</label>

                <div class="flex items-center justify-between mb-1">
                  <div class="bg-dark-3 btn-group_spacing flex items-center justify-between mb-1">
                      <FormRadio v-model="rtmpSource" inputValue="primary" name="rtmp-source" label="Primary" @update:modelValue="onRtmpSourceChange" />
                      <FormRadio v-model="rtmpSource" inputValue="backup" name="rtmp-source" label="Backup" @update:modelValue="onRtmpSourceChange" />
                    </div>
                </div>

            </div>
          </div> -->

          <div class="mb-4 flex flex-wrap" v-if="failoverIgestActive">
            <div class="w-full">
              <label v-if="publishType === 'rtmp'" class="">Ingest URL</label>
              <div v-if="publishType === 'rtmp'" :class="{
                'input-container': true,
                'disabled-container': !this.hasFailoverIngestFeature
              }">

                <div class="mb-3 flex items-center flex-nowrap">
                  <FormInput class="w-[1%] flex-grow" :modelValue="getStreamPushUrl(true)" readonly
                    :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState"
                    @click="doCopy(getStreamPushUrl(true))" />
                  <ButtonCopyToClipboard :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState"
                    class="z-10" :text="getStreamPushUrl(true)" />
                </div>
              </div>

              <label v-if="publishType === 'rtmp'">Primary Streaming Key</label>
              <label v-if="publishType === 'srt'">Primary ingest</label>
              <IngestStatus v-if="failoverIgestActive" :alive="primaryStreamAlive" class="ml-3 align-middle" />
              <div :class="{
                'input-container': true,
                'disabled-container': !this.hasFailoverIngestFeature
              }">
                <div class="flex items-center flex-nowrap">
                  <FormInput v-if="streamKeyVisible" class="w-[1%] flex-grow" v-model="streamKey"
                    :modelValue="getStreamPushUrl(true)"
                    :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState" readonly
                    @click="doCopy(streamKey)" />
                  <FormInput v-if="!streamKeyVisible"
                    :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState" readonly
                    class="w-[1%] flex-grow" modelValue="xxxxxxxxxxxxxxxxx" />
                  <FormButton :disabled="!this.hasFailoverIngestFeature" v-if="publishType === 'rtmp'"
                    class="relative z-10" isLink isIcon type="link" size="sm" @click="toggleStreamKeyVisibility">
                    <span v-if="streamKeyVisible" class="show-counter absolute text-c-dark-7 text-xs">({{
                      streamKeyVisibleTimeout / 1000 }})</span>
                    <icon-base class="" fill="none">
                      <IconEye v-if="!streamKeyVisible" />
                      <IconEyeCrossed v-else />
                    </icon-base>
                  </FormButton>
                  <ButtonCopyToClipboard :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState"
                    class="relative z-10" :text="streamKey" />
                </div>
              </div>

              <label class="mt-3" v-if="publishType === 'rtmp'">Backup Streaming Key</label>
              <label class="mt-3" v-if="publishType === 'srt'">Backup ingest</label>
              <IngestStatus v-if="failoverIgestActive" :alive="backupStreamAlive" class="ml-3 align-middle" />
              <div :class="{
                'input-container': true,
                'disabled-container': !this.hasFailoverIngestFeature
              }">
                <div class="flex items-center flex-nowrap">
                  <FormInput v-if="streamKeyVisible2" class="w-[1%] flex-grow" v-model="streamKey2"
                    :modelValue="getStreamPushUrl(true)"
                    :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState" readonly
                    @click="doCopy(streamKey2)" />
                  <FormInput :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState" readonly
                    v-if="!streamKeyVisible2" class="w-[1%] flex-grow" modelValue="xxxxxxxxxxxxxxxxx" />
                  <FormButton :disabled="!this.hasFailoverIngestFeature" v-if="publishType === 'rtmp'"
                    class="relative z-10" isLink isIcon type="link" size="sm" @click="toggleStreamKeyVisibility2">
                    <span v-if="streamKeyVisible2" class="show-counter absolute text-c-dark-7 text-xs">({{
                      streamKeyVisibleTimeout2 / 1000 }})</span>
                    <icon-base class="" fill="none">
                      <IconEye v-if="!streamKeyVisible2" />
                      <IconEyeCrossed v-else />
                    </icon-base>
                  </FormButton>
                  <ButtonCopyToClipboard :disabled="!this.hasFailoverIngestFeature || !failoverIngestToggleState"
                    class="relative z-10" :text="streamKey2" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <confirm-modal modal-id="modal-backup-toggle-warning-settings" message="Update your stream key?"
      ok-text="Update stream key" cancel-text="Cancel" :confirmCancelEvent="false"
      @modal-confirm="onBackupModalToggleConfirm" @modal-cancel="onBackupModalToggleCancel">
      <template v-if="failoverIngestToggleState">
        <p class="text-sm !mb-4">Changing this setting regenerates your stream key. Update your streaming software with the
          new key to avoid interruptions.</p>
        <p class="text-sm">Use the same encoder and identical settings for both the primary and backup streams. Mixing
          encoders or configurations (for example, OBS for one and a different tool for the other) can cause glitches or
          playback issues.</p>
      </template>
      <template v-else>
        <p class="text-sm">Changing this setting regenerates your stream key. Update your streaming software with the new
          key to avoid disruptions to your broadcast.</p>
      </template>
    </confirm-modal>
    <confirm-modal modal-id="feature-upgrade" ok-text="Upgrade Now" cancel-text="Later"
      @modal-confirm="navigateToBilling()">
      <p class="mb-0 text-s-m"><a target="_blank" class="text-reset text-underline" href="/app/subscribe">Upgrade</a> to
        access this feature. Check <a target="_blank" class="text-reset text-underline text-nowrap"
          href="https://castr.com/pricing">Pricing page</a> to learn more about eligible plans.</p>
    </confirm-modal>

  </div>
</template>

<script>
import Tooltip from '@/components/Atoms/Tooltip.vue'
import _ from 'lodash';
import { track, EVENTS } from '@/lib/tracking'
import StreamService from '@/services/StreamService';
import AlertModal from '@/components/modals/AlertModal.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import StreamAbrSettingsModal from '@/components/modals/StreamAbrSettingsModal.vue';
import { mapGetters } from 'vuex'
import StreamRegion from '@/components/ui/StreamRegion.vue';
import FormButton from '@/components/Atoms/FormButton.vue';
import TabGroup from '@/components/Atoms/TabGroup.vue';
import TabItem from '@/components/Atoms/TabItem.vue';
import Alert from '@/components/Atoms/Alert.vue';
import FormInput from '@/components/Atoms/FormInput.vue';
import FormCheckbox from '@/components/Atoms/FormCheckbox.vue';
import FormRadio from '@/components/Atoms/FormRadio.vue';
import FormSwitch from '@/components/Atoms/FormSwitch.vue';
import IconCopy from '@/components/icon/IconCopy.vue';
import IconEye from '@/components/icon/IconEye.vue';
import IconEyeCrossed from '@/components/icon/IconEyeCrossed.vue';
import IconBase from '@/components/icon/IconBase.vue';
import IconBookOpen from '@/components/icon/IconBookOpen.vue';
import ButtonCopyToClipboard from '@/components/Moleculas/ButtonCopyToClipboard.vue';
import Badge from '@/components/Badge.vue';
import IngestPreview from '@/components/ui/StreamSidebar/IngestPreview.vue';
import IngestStatus from '@/components/ui/StreamSidebar/IngestStatus.vue';
import MonitoringChart from '@/views/StreamsDash/MonitoringChart.vue';
import { showModal } from '@/Utils/modalBus';

export default {
  name: 'StreamsManageSettingsBackup',
  components: {
		Tooltip,
    Alert,
    AlertModal,
    ConfirmModal,
    StreamAbrSettingsModal,
    StreamRegion,
    FormButton,
    FormInput,
    FormCheckbox,
    FormSwitch,
    FormRadio,
    TabGroup,
    TabItem,
    IconCopy,
    IconEye,
    IconEyeCrossed,
    IconBase,
    IconBookOpen,
    ButtonCopyToClipboard,
    Badge,
    IngestPreview,
    IngestStatus,
    MonitoringChart
  },
  props: {
    stream: {
      type: Object,
      required: true,
      validator(v) {
        return Object.prototype.hasOwnProperty.call(v, '_id');
      }
    },
    streamAlive: {
      type: Boolean
    },
    backupStreamAlive: {
      type: Boolean,
      default() { return false; }
    },
    primaryStreamAlive: {
      type: Boolean,
      default() { return false; }
    },
    mediaPulse: {
      type: Object,
      default() { return {}; }
    },
    mediaPulsePrimary: {
      type: Object,
      default() { return {}; }
    },
    mediaPulseBackup: {
      type: Object,
      default() { return {}; }
    },
    linkedSource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      publishType: 'rtmp',
      switchRegionProcessing: false,

      rtmpSource: 'primary',
      failoverIgestActive: true,
      // hasFailoverIngestFeature: true,

      streamKeyVisible: false,
      streamKeyVisibleTimeout: 0,
      streamKeyVisibleTimeoutCtrl: null,

      streamKeyVisible2: false,
      streamKeyVisibleTimeout2: 0,
      streamKeyVisibleTimeoutCtrl2: null,

      selectedTab: 'encoder',
      isPasswordEnabled: true,

      streamMeta: null,
      featureProcessing: false,

      failoverIngestToggleProcessing: false,
      failoverIngestToggleState: false
    };
  },
  computed: {
    ...mapGetters({
      bitradeLadderFlag: "User/bitradeLadderFlag"
    }),
    isMonitoringAllowed() {
      const liveSub = _.find(this.$store.state.User.subscriptions, { category: 'live' }) || {}
      return !!liveSub.enabled
    },
    primaryIngestKey() {
      return `${this.stream.key}_primary`
    },
    backupIngestKey() {
      return `${this.stream.key}_backup`
    },
    // When both ingests are live, flag any encoder settings that don't match —
    // a mismatch means the failover switchover may not be seamless.
    ingestMismatch() {
      const a = this.mediaPulsePrimary || {}
      const b = this.mediaPulseBackup || {}
      if (!this.primaryStreamAlive || !this.backupStreamAlive) return []
      const diffs = []
      if (a.width && b.width && (a.width !== b.width || a.height !== b.height)) diffs.push('resolution')
      if (a.fps && b.fps && Math.round(a.fps) !== Math.round(b.fps)) diffs.push('frame rate')
      const codecA = (a.codecs || []).map((c) => c.codec).filter(Boolean).sort().join('/')
      const codecB = (b.codecs || []).map((c) => c.codec).filter(Boolean).sort().join('/')
      if (codecA && codecB && codecA !== codecB) diffs.push('codec')
      return diffs
    },
    ingestMismatchLabel() {
      const d = this.ingestMismatch
      if (d.length <= 1) return d[0] || ''
      if (d.length === 2) return `${d[0]} and ${d[1]}`
      return `${d.slice(0, -1).join(', ')}, and ${d[d.length - 1]}`
    },
    tooltipMessage() {
      if (this.linkedSource) {
        return 'Backup cannot be enabled while a linked source is set. Remove the linked source to continue.'
      }
      if (this.streamAlive) {
        return 'You cannot change this while the stream is live.'
      }
      if (this.failoverLimitReached) {
        return `Need more backup streams? <span class="underline cursor-pointer" onclick="Intercom('show')">Contact sales</span> to upgrade your limit.`
      }
      return 'You cannot change this while the stream is live.'
    },
    streamKey() {
      const prefix = this.failoverIgestActive && this.hasFailoverIngestFeature ? '_primary' : ''
      let pushKey = this.stream.key + prefix;
      if (this.stream.config && this.stream.config.password && this.isPasswordEnabled) {
        pushKey += '?password=' + this.stream.config.password;
      }

      if (this.publishType === 'srt') {
        const hostname = this.getStreamPushUrl(true, true)
        let pass = ''
        if (this.stream.config && this.stream.config.password && this.isPasswordEnabled) {
          pass = ',password=' + this.stream.config.password;
        }
        return `${hostname}:9998?pkt_size=1316&streamid=#!::r=${this.stream.key}_primary${pass},m=publish`
      }

      return pushKey;
    },
    streamKey2() {
      let pushKey = `${this.stream.key}_backup`;
      if (this.stream.config && this.stream.config.password && this.isPasswordEnabled) {
        pushKey += '?password=' + this.stream.config.password;
      }

      if (this.publishType === 'srt') {
        const hostname = this.getStreamPushUrl(true, true)
        let pass = ''
        if (this.stream.config && this.stream.config.password && this.isPasswordEnabled) {
          pass += ',password=' + this.stream.config.password;
        }
        return `${hostname}:9998?pkt_size=1316&streamid=#!::r=${this.stream.key}_backup${pass},m=publish`
      }

      return pushKey;
    },
    subscription() {
      return this.$store.state.User.subscriptions;
    },
    baseSubscription() {
      const baseSub = _.find(this.subscription, { category: this.stream.type }) || {};
      return baseSub;
    },
    hasFailoverIngestFeature() {
      const baseSub = this.baseSubscription;
      return !!_.get(baseSub, 'definitionOverride.failoverIngest', _.get(baseSub, 'package.definition.failoverIngest', false));
    },
    maxFailoverIngest() {
      const baseSub = this.baseSubscription;
      return Number(_.get(baseSub, 'definitionOverride.maxFailoverIngest', _.get(baseSub, 'package.definition.maxFailoverIngest', 0))) || 0;
    },
    failoverIngestUsedCount() {
      const streams = this.$store.state.Streams.streams || [];
      return streams.filter((s) => s.type === this.stream.type && s.failoverIngest).length;
    },
    failoverLimitReached() {
      // Allow turning an already-enabled backup off; only block enabling new ones once the limit is hit.
      if (this.failoverIngestToggleState) return false;
      return this.failoverIngestUsedCount >= this.maxFailoverIngest;
    },
  },
  watch: {
  },
  async mounted() {
    this.streamMeta = await StreamService.getStreamMetadata(this.stream._id)
    this.failoverIngestToggleState = this.stream.failoverIngest;
  },
  methods: {
    gotoDoc() {
      window.open('https://docs.castr.com/en/articles/10586235-how-to-set-up-a-vod-backup-for-seamless-livestream-failover', '_blank');
    },
    async toggleBackup() {
      showModal('modal-backup-toggle-warning-settings');
    },
    onEncoderTabClick() {
      this.selectedTab = 'encoder';
      showModal('modal-demo-video');
    },
    onFileTabClick() {
      this.selectedTab = 'file';
      showModal('modal-demo-video');
    },
    async onBackupModalToggleCancel() {
      this.failoverIngestToggleState = !this.failoverIngestToggleState;
    },
    async onBackupModalToggleConfirm() {
      if (!this.hasFailoverIngestFeature) {
        this.failoverIngestToggleState = false;
        return
      }

      this.failoverIngestToggleProcessing = true;
      try {
        await StreamService.toggleStreamFailoverIngest(this.stream._id, this.failoverIngestToggleState);
        track(EVENTS.BACKUP_CONFIGURED, {
          streamId: this.stream._id,
          streamType: this.stream.type,
          backupEnabled: this.failoverIngestToggleState,
        });
      } catch (e) {
        this.failoverIngestToggleState = !this.failoverIngestToggleState;
        this.$notify({
          group: 'error',
          text: (e && e.message) || 'could not toggle backup stream ingest'
        });
      }

      // TODO: remove here mutation of prop and emit event to parent component
      // backupMediaPulse must stop processing when backup ingest disabled
      this.stream.failoverIngest = this.failoverIngestToggleState;

      this.$emit('backup-toggle', { status: this.failoverIngestToggleState });

      this.failoverIngestToggleProcessing = false;
      if (this.failoverIngestToggleState) window.Intercom('trackEvent', 'toggle-backup-on')
    },
    toggleStreamKeyVisibility() {
      window.clearInterval(this.streamKeyVisibleTimeoutCtrl);
      const newState = !this.streamKeyVisible;
      this.streamKeyVisible = newState;

      if (newState) {
        const timeout = 1000;
        this.streamKeyVisibleTimeout = 9000;
        this.streamKeyVisibleTimeoutCtrl = setInterval(() => {
          this.streamKeyVisibleTimeout -= timeout;
          if (!this.streamKeyVisibleTimeout)
            this.toggleStreamKeyVisibility();
        }, timeout);
      }
    },
    toggleStreamKeyVisibility2() {
      window.clearInterval(this.streamKeyVisibleTimeoutCtrl2);
      const newState = !this.streamKeyVisible2;
      this.streamKeyVisible2 = newState;

      if (newState) {
        const timeout = 1000;
        this.streamKeyVisibleTimeout2 = 9000;
        this.streamKeyVisibleTimeoutCtrl2 = setInterval(() => {
          this.streamKeyVisibleTimeout2 -= timeout;
          if (!this.streamKeyVisibleTimeout2)
            this.toggleStreamKeyVisibility2();
        }, timeout);
      }
    },
    async doCopy(value) {
      await navigator.clipboard.writeText(value);
      this.$notify({ group: 'info', text: 'Copied to clipboard' });
    },
    getStreamPushUrl(backupIngest, srt = false) {
      const stream = _.cloneDeep(this.stream)
      // uiRegion is a UI-only hack applied once on mount; a stream refresh
      // (e.g. after toggling backup) replaces the stream with a store clone
      // that lacks it, so fall back to the persisted region.
      const region = stream.uiRegion || stream.region || {}
      let hostname = region.hostname;

      if (!region.rtmpPort) {
        region.rtmpPort = 1935
      }

      // if (this.failoverIngestToggleState && !backupIngest && this.hasFailoverIngestFeature) {
      // 	hostname = this.failoverPrimaryIngest;
      // }

      // if (this.failoverIngestToggleState && backupIngest) {
      // 	hostname = this.failoverBackupIngest;	
      // }

      let pushUrl = `rtmp://${hostname}`;
      if (srt) {
        pushUrl = `srt://${hostname}`
      }

      if (region.rtmpPort !== 1935) {
        pushUrl += ':' + region.rtmpPort;
      }

      // @todo
      let prefixPath = _.get(region, 'config.prefixPath');
      prefixPath = prefixPath || '/static';
      prefixPath = _.replace(prefixPath, /^\/\//gi, '/');

      if (!srt) {
        pushUrl += prefixPath;
      }

      if (!this.hasFailoverIngestFeature && backupIngest) {
        pushUrl = 'xxxxxxxxxxxxxx';
      }

      if (this.stream.user === '62c4b3398b2e840b11244bfd') {
        pushUrl = 'rtmp://fifa.castr.io/static'
      }

      return pushUrl;
    },
    async switchStreamRegion(region) {
      if (!region) {
        return;
      }

      this.switchRegionProcessing = true;
      try {
        await StreamService.switchStreamRegion(this.stream._id, region._id, this.transcoderView);
        // this.closeRegionDropDownMenu();

        const selectedProps = _.pick(region, ['hostname', 'identifier', 'name']);
        const newRegion = _.assign({}, this.stream.region, selectedProps)
        this.$emit('stream-updated', { uiRegion: region });

        this.$notify({
          group: 'success',
          text: `Region changed to ${region.name}.`
        });
      } catch (e) {
        this.$notify({
          group: 'error',
          text: (e && e.message) || 'could not switch stream region'
        });
      }
      if (region.hostname === 'live.castr.io') {
        this.failoverIngestToggleProcessing = true;
      } else this.failoverIngestToggleProcessing = false;

      this.switchRegionProcessing = false;
    },
    onPublishTypeChange(type) {
      this.publishType = type;
      this.streamKeyVisible = false
      this.streamKeyVisible2 = false
      if (type === 'srt') {
        this.streamKeyVisible = true
        this.streamKeyVisible2 = true
      }
    },
    navigateToBilling() {
      if ((this.stream.type === 'live') || this.stream.type === 'vod') {
        window.location.href = '/app/subscribe?category=live';
      } else {
        window.location.href = '/app/subscribe';
      }
    },
    async toggleFeature(featureName, flag) {
      if (featureName === 'abr') {
        this.toggleABR()
        return
      }
      await this.saveSetting(featureName, flag, true)
    },
    async saveSetting(key, value, successToast = false) {
      this.featureProcessing = true;
      try {
        await StreamService.saveStreamMetadata(this.stream._id, key, value)
        if (successToast) {
          this.$notify({ group: 'success', text: 'Setting saved' })
        }
      } catch (e) {
        this.$notify({ group: 'error', text: 'Unable to save your changes.' })
      }
      this.featureProcessing = false;
    }
  }
};
</script>

<style scoped>
.doc-area {
  display: flex;
  justify-content: center;
}

.doc {
  font-size: var(--font-s-ss);
  display: flex;
  align-items: end;
}

.doc svg {
  margin-right: 4px;
  max-width: 16px;
  width: 100%;
  transform: translateY(-1px);
}

.active-tab-selected {
  background-color: rgba(52, 62, 97, 1);
  color: white;
}

.file-btn-tab {
  width: 190px;
  display: flex;
  justify-content: flex-start;
}

.backup-section {
  background-color: var(--surface-1);
  border-radius: 12px;
}

.feature-item::after {
  /* border-top: none; */
}

.input-group {
  flex-wrap: nowrap;
}
</style>
